import { render, staticRenderFns } from "./FormRiskComponent.vue?vue&type=template&id=445b3a16"
import script from "./FormRiskComponent.vue?vue&type=script&lang=js"
export * from "./FormRiskComponent.vue?vue&type=script&lang=js"
import style0 from "./FormRiskComponent.vue?vue&type=style&index=0&id=445b3a16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports